import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable, toJS } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Tabela} from "../../comum/components/Tabela";
import ContratacoesVigentesStore from "../stores/ContratacoesVigentesStore";
import {
    formatarCpf, formatarDataISO8601, formatarNomeProduto, motivoContratacaoFormatter, nullable, ordenarData,
    slaFormatter,
} from "../../../utils/formatar";
import {sortAlphaNum} from "../../../utils/ordenar";
import {ContratacoesFiltro} from "../components/ContratacoesFiltro";
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";

const COLUNAS = [
    {
        field: "idSolicitacaoExibicao",
        label: "Solicitação",
        funcaoOrdenacao: sortAlphaNum.bind("idSolicitacaoExibicao")
    },{
        field: "nomeProfissional",
        label: "Nome profissional"
    },{
        field: "cpfProfissional",
        label: "CPF"
    },{
        field: "solicitante",
        label: "Solicitante"
    },{
        field: "gestor",
        label: "Gestor"
    },{
        field: "cargo",
        label: "Cargo"
    },{
        field: "motivoContratacao",
        label: "Motivo contratação",
        dataFormat: motivoContratacaoFormatter
    },{
        field: "justificativa",
        label: "Justificativa"
    },{
        field: "produto",
        label: "Projeto/centro de resultado/finalidade",
        dataFormat: formatarNomeProduto
    },{
        field: "dataInicio",
        label: "Data de início",
        funcaoOrdenacao: ordenarData.bind("dataInicio")
        //dataFormat: formatarDataISO8601
    },{
        field: "dataTermino",
        label: "Data de término",
        funcaoOrdenacao: ordenarData.bind("dataTermino")
        //dataFormat: formatarDataISO8601
    },{
        field: "empresa",
        label: "ETT"
    }
];
@inject("store")
@DataWrapper
@observer
export class ContratacoesVigentes extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                 = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                 = new ContratacoesVigentesStore(this.props.history, this.props.location);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Contratações vigentes");

        // tratamento para visão mobile
        if (this.appStore.width < 768) {
            this.controller.carregarTabela();
        }

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            },{
                label: "Filtrar",
                icone: "search",
                acao: () => this.modalStore.toggleModal('filtrar')
            }
        ]);
    }


    obterTituloMobile = (objeto) => {
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao : "") + (objeto.cargo != null ? " - " + objeto.cargo : "") + (objeto.nomeProduto != null ? " para " + objeto.nomeProduto : "");
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { objeto.sla && <span>{ "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/></span>}
                { "Nome profissional: " + nullable(objeto.nomeProfissional)}<br/>
                { "CPF: " + nullable(formatarCpf(objeto.cpfProfissional))}<br/>
                { "Solicitante: " + nullable(objeto.solicitante)}<br/>
                { "Gestor: " +  nullable(objeto.gestor)}<br/>
                { "Cargo: " +  nullable(objeto.cargo)}<br/>
                { "Motivo contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Vigência: " + nullable(objeto.dataInicio)}
                { " à " + nullable(objeto.dataTermino)}<br/>
                { "Empresa: " + nullable(objeto.empresa)}<br/>
            </div>
        )
    };

    render() {
        let acoesItens = [];


        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.appStore.width > 768 && <ContratacoesFiltro controller={this.controller}/>}

                        <TabelaFluxo
                            keyField={"idSolicitacaoExibicao"}
                            nomeFluxo={'Solicitação'}
                            parametroVisualizar={"idSolicitacaoExibicao"}
                            parametroClonar={'solicitacaoId'}
                            temBusca={true}
                            habilitarSelecaoMultipla={true}
                            listaItens={toJS(this.controller.contratacoesvigentesLista)}
                            colunas={COLUNAS}
                            acoesItens={"botoesContratacoesVigentes"}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            onChange={(value) => this.controller.setLista(value)}
                            onCardClick={this.props.onCardClick}
                            loading={this.controller.loading}
                            colunaOrdenacaoPadrao={'idSolicitacaoExibicao'}
                            tipoOrdenacaoPadrao={'asc'}
                            mobileFilter={<ContratacoesFiltro controller={this.controller}/>}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
